// Where a column's `grain` differs from its dataset's `section_grain`, its value is a parent's,
// copied onto every child row: sum over-counts, avg is child-weighted, min/max/distinct_count
// are exact. Mirrors TableColumn#repeated_on_each_row?; keep the two in step. A column with
// `counted_once_per` set is summed once per parent server-side, so none of that applies.
export const isRepeatedGrain = (column) =>
  Boolean(column?.grain) &&
  Boolean(column?.section_grain) &&
  column.grain !== column.section_grain &&
  !column.counted_once_per

// Human-readable reason, for a tooltip or helper text next to a narrowed menu.
export const repeatedGrainReason = (column) => {
  if (!isRepeatedGrain(column)) return null

  return `${column.display_name || column.name} belongs to a parent record and repeats on every row of this dataset, so it cannot be summed or averaged here.`
}
